import { render, staticRenderFns } from "./lecture-auth.vue?vue&type=template&id=535738b2"
import script from "./lecture-auth.vue?vue&type=script&lang=js"
export * from "./lecture-auth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports